<template>
  <div class="home">
    <div class="banner">
      <img src="@/assets/banner1.png" alt="" />
    </div>

    <div class="card">
      <van-row gutter="20">
        <van-col span="12">
          <div class="card-item item1" @click="goPage('/appointment')">
            <van-icon class="icon" name="flower-o" />
            <p>预约祭扫</p>
          </div>
        </van-col>
        <van-col span="12">
          <div class="card-item item2" @click="goPage('/my')">
            <van-icon class="icon" name="notes-o" />
            <p>我的预约</p>
          </div>
        </van-col>
      </van-row>
      <!-- <van-row gutter="20">
        <van-col span="12">
          <div class="card-item item3" @click="goPage('/show')">
            <van-icon class="icon" name="newspaper-o" />
            <p>预约展示</p>
          </div>
        </van-col>
        <van-col span="12"> </van-col>
      </van-row> -->
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goPage(path) {
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  .banner {
    width: 100%;
    height: 180px;
    background-color: #ccc;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .card {
    padding: 20px;
    &-item {
      height: 100px;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: column;
      text-align: center;
      color: #fff;
      .icon {
        font-size: 40px;
        color: #fff;
      }
      p {
        font-size: 18px;
        margin-top: 10px;
      }
    }
    .item1 {
      background-color: rgba(129, 211, 248, 1);
    }
    .item2 {
      background-color: rgba(245, 154, 35, 0.83921568627451);
    }
    .item3 {
      background-color: rgba(112, 182, 3, 0.729411764705882);
    }
  }
}
</style>
